import React from 'react';

const Footer = () => {
    return (
        <div>
            <footer class=" shadow-lg text-secondary pt-5 text-center" style={{minHeight:'80px'}}>
        <p>&copy;2021 Albub Yusuf</p>
    </footer> 
        </div>
    );
};

export default Footer;